<div class="govuk-grid-row">
  <div class="govuk-grid-column-full">
    @if (got403FromServer) {
      <p>You have been signed out due to inactivity or your account permissions changed recently.</p>
      <p>Sign in again to continue using this service.</p>
    } @else {
      <p>You have been signed out.</p>
    }

    <a [routerLink]="['/login']" role="button" draggable="false" class="govuk-button"> Sign in </a>
  </div>
</div>
